import React from 'react';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { HorizontalDivider } from '../dividers';
import { st, classes } from './start-root-box-section.st.css';
import { StartRootBoxSectionComponent } from './start-root-box-section-component';
const StartRootBoxSectionNoMemo = ({ isListEmpty, someoneIsTyping, appHeaderIsVisible, shouldShowCommentBox, boxRating, ...sortProps }) => {
    const { hideHeaderDivider } = useConfiguration();
    const { isMobile } = useApi((state, actions, _, ctx) => ({
        isMobile: getIsMobile(state),
        biAttemptLoginSignup: actions.biAttemptLoginSignup,
        requestLoginAction: actions.requestLogin,
    }));
    const shouldShowDivider = appHeaderIsVisible && !hideHeaderDivider;
    return (React.createElement("div", { className: st(classes.root, {
            isMobile,
            withTopMargin: appHeaderIsVisible && !!hideHeaderDivider,
            withoutCommentBox: !shouldShowCommentBox,
        }) },
        shouldShowDivider ? React.createElement(HorizontalDivider, { className: classes.divider, type: "header" }) : null,
        React.createElement(StartRootBoxSectionComponent, { shouldShowCommentBox: shouldShowCommentBox, hideSort: sortProps.hideSort, selectedSort: sortProps.selectedSort, isListEmpty: isListEmpty, boxRating: boxRating, someoneIsTyping: someoneIsTyping })));
};
const StartRootBoxSection = React.memo(StartRootBoxSectionNoMemo);
export default StartRootBoxSection;
//# sourceMappingURL=start-root-box-section.js.map